module.exports = __webpack_public_path__ + "img/ES0211.6cb76fdf.png";